<template>
  <div class="side-nav-container">
    <div class="tab-title">
        <span>百运网使用教程</span>
        <i class="el-icon-close" @click="handleClose"></i>
    </div>
    <!-- 顶部切换标签 -->
    <div class="tab-bar">
      <div 
        :class="['tab-item', { active: currentTab === 'priceGuide' }]" 
        @click="currentTab = 'priceGuide'"
      >
        <span>查价指引</span>
        <img 
          :style="{ visibility: currentTab === 'priceGuide' ? 'visible' : 'hidden' }"
          src="../../../../static/newStatic/img/guide/ic_downward@2x.png" 
          width="19px" 
          height="7px" 
          class="active-indicator"
          alt="查价指引激活指示器"
        >
      </div>
      <div 
        :class="['tab-item', { active: currentTab === 'personalCenter' }]" 
        @click="currentTab = 'personalCenter'"
      >
        <span>个人中心</span>
        <img 
          :style="{ visibility: currentTab === 'personalCenter' ? 'visible' : 'hidden' }"
          src="../../../../static/newStatic/img/guide/ic_downward@2x.png" 
          width="19px" 
          height="7px" 
          class="active-indicator"
          alt="个人中心激活指示器"
        >
      </div>
    </div>

    <!-- 侧边菜单 - 查价指引 -->
    <div class="menu-wrapper" v-if="currentTab == 'priceGuide'">
      <div class="menu-group">
        <div class="menu-title" @click="toggleMenu('home')" :class="{'ling':menuStates.home}">
          <div class="flex"><span class="number">1</span> 首页</div>
          <i class="arrow el-icon-arrow-down" :class="{ rotate: menuStates.home }"></i>
        </div>
         <ul class="sub-menu" :class="{ 'sub-menu-open': menuStates.home }">
          <li v-for="(item, index) in homeSubMenu" :key="index" >
            {{ item.label }} 
            <button class="start-btn" @click="handleStart(item,1)">开始</button>
          </li>
        </ul>
      </div>

      <div class="menu-group">
        <div class="menu-title" @click="toggleMenu('priceResult')" :class="{'ling':menuStates.priceResult}">
          <div class="flex"><span class="number">2</span> 查价结果页</div>
          <i class="arrow el-icon-arrow-down" :class="{ rotate: menuStates.priceResult }"></i>
        </div>
        <ul class="sub-menu" :class="{ 'sub-menu-open': menuStates.priceResult }">
          <li v-for="(item, index) in ResultMenu" :key="index" >
            {{ item.label }} 
            <button class="start-btn" @click="handleStart(item,2)">开始</button>
          </li>
        </ul>
      </div>

      <div class="menu-group">
        <div class="menu-title" @click="toggleMenu('workbench')" :class="{'ling':menuStates.workbench}">
          <div class="flex"><span class="number">3</span> 百运工作台</div>
          <i class="arrow el-icon-arrow-down" :class="{ rotate: menuStates.workbench }"></i>
        </div>
        <ul class="sub-menu" :class="{ 'sub-menu-open': menuStates.workbench }">
          <li>查价指引<button class="start-btn" @click="gotoCustomerCenter(1)">开始</button></li>
        </ul>
      </div>
    </div>

    <!-- 侧边菜单 - 个人中心 -->
    <div class="menu-wrapper" v-if="currentTab == 'personalCenter'">
        <div class="menu-group">
        <div class="menu-title">
          <div class="flex">工作台-板块介绍</div>
          <button class="start-btn" @click="gotoCustomerCenter(2)">开始</button>
        </div>
        </div>
    </div>

    <div class="bottom-container">
      <div class="close-btn" @click="handleClose">关闭</div>
      <div class="img">
        <img src="../../../../static/newStatic/img/guide/side1.png" width="240" height="240" alt="底部装饰图">
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/ask/eventBus";
export default {
  name: 'SideNav',
  data() {
    return {
      currentTab: 'priceGuide', 
      menuStates: {
        home: false,
        priceResult: false,
        workbench: false
      },
      homeSubMenu: [
        { label: '国际快递',type:'express', path:''},
        { label: 'FBA头程',type:'fba', path:'' },
        { label: '国际专线',type:'special', path:'' },
        { label: '小包专线',type:'packet', path:'' },
        { label: '国际空运',type:'air', path: '' },
        { label: '海运散货',type:'sea', path: ''  },
        { label: '海运整柜',type:'seaFull', path: '' }
      ],
      ResultMenu: [
        { label: '国际快递',type:'express', path:'exp/list/1.html'},
        { label: 'FBA头程',type:'fba', path:'fba/list/1.html'},
         { label: '国际专线',type:'special', path:'specialLine/LineList/1.html'},
        { label: '小包专线',type:'packet', path:'specialLinePacket/list/1.html' },
        { label: '国际空运',type:'air', path: 'frontAirList/1.html' },
        { label: '海运散货',type:'sea', path: 'sea/list/1.html' },
        { label: '海运整柜',type:'seaFull', path:'seaFull/list/1.html' }
      ]
    }
  },
  methods: {
    gotoCustomerCenter(val){
      let title = val == 1 ? '客户中心-查价指引':'客户中心-板块介绍';
      this.userGuide(document.title,title,true);
      window.location.href = this.$apiAir+'customerCenter?isGuide='+val;
    },
    toggleMenu(type) {
      Object.keys(this.menuStates).forEach(key => {
        // 只有当前点击的菜单可以切换状态，其他菜单强制关闭
        this.menuStates[key] = key === type ? !this.menuStates[key] : false;
      });
    },
     handleStart(item,val) {
      let title = val == 1 ? '-首页指引':'查价指引'
      console.log("===this.$route.fullPath",this.$route,this.$route.fullPath);
      if((this.$route.path != item.path)
      ){
        this.browserHref(this.$nuxtPage+item.path+"?isGuide=true", 1);
      }
      let Data = Object.assign(
          { type: item.type, show: true }, 
          );
      localStorage.setItem("checkTypeGuide", JSON.stringify(Data));
      //setTimeout(() => {
        bus.$emit("showGuide");
        //this.$store.commit("user/IS_Guidance",true);
      //}, 1000) 
      this.userGuide(document.title,item.label+title,true);
      this.handleClose();
    },
    handleClose() {
      console.log('执行关闭操作');
      this.$emit("close");
    }
  }
}
</script>

<style scoped lang='scss'>
/* 样式部分保持不变 */
.side-nav-container {
  //min-width: 360px;
  background: #F3F8FF;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  
  .tab-title{
    height: 24px;
    padding: 16px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #EBEBEB;
    span{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        line-height: 24px;
    }
    .el-icon-close{
      cursor: pointer;
    }
  }
}

/* 顶部切换标签 */
.tab-bar {
  display: flex;
  margin-bottom: 20px;
  width: 100%;
}

.tab-item {
  flex: 1;
  cursor: pointer;
  height: 56px; /* 固定高度，避免切换时高度变化 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  position: relative;
  transition: color 0.2s ease; /* 平滑过渡文字颜色 */
}

.tab-item span {
  display: inline-block;
  text-align: center;
  &:hover{
    color: #0046B9;
  }
}

.tab-item.active {
  color: #4B58E5;
}

/* 激活状态指示器图片样式 */
.active-indicator {
  margin-top: 4px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  transition: opacity 0.2s ease; /* 平滑过渡显示/隐藏 */
}

/* 菜单整体 */
.menu-wrapper {
  //min-width: 312px;
  margin: 0 24px;
  transition: all 0.3s ease; /* 菜单切换时平滑过渡 */
}
.menu-group {
  margin-bottom: 8px;
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0);
  &:hover{
    border: 1px solid #99B5E3 !important;
  }
  &:active{
    border: 1px solid #99B5E3 !important;
  }
}
.menu-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 15px;
  cursor: pointer;
  border-radius: 4px;
  height: 48px;
  background: rgba(255,255,255,0);
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  
  .number{
    width: 20px;
    height: 20px;
    background: rgba(0,0,0,0.08);
    border-radius: 4px;
    display: block;
    align-content: center;
    text-align: center;
    margin-right: 8px;
  }
}
.ling{
    border-bottom: 1px solid #EBEBEB;
}
.arrow {
  transition: transform 0.3s ease;
}
.rotate {
  transform: rotate(180deg);
}

/* 子菜单 */
.sub-menu {
  list-style: none;
  padding: 0 15px;
  margin: 0;
  //margin-top: 8px;
  max-height: 0;          // 默认高度为0（隐藏）
  overflow: hidden;       // 超出部分隐藏
  transition: max-height 0.3s ease-out;  // 平滑过渡
}

/* 子菜单展开样式 */
.sub-menu-open {
  max-height: 500px;      // 足够大的高度容纳内容
  transition: max-height 0.5s ease-in;   // 展开动画
  padding-bottom: 8px;   // 增加底部内边距，让内容更美观
  padding-top: 8px; 
}

.sub-menu li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  cursor: pointer;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #333333;
}
.start-btn {
  width: 64px;
  height: 28px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #DDDDDD;
  cursor: pointer;
  &:hover{
    background: rgba(0,71,185,0.04);
    border: 1px solid #7097D8;
    color: #0046B9;
  }
  &:active{
    background: rgba(0,70,185,0.08);
    border: 1px solid #0046B9;
    color: #0046B9;
  }
}
.bottom-container {
  margin-top: auto;
  padding: 24px;
  box-sizing: border-box;
  
  .img {
    text-align: right;
    margin-top: 16px;
    pointer-events: none; 
  }
}
.close-btn {
    //min-width: 312px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0);
    cursor: pointer;
    display: block;
    align-content: center;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    position: relative;
    z-index: 1;
    &:hover{
      border: 1px solid rgba(0,70,185,0.16);
    }
    &:active{
      border: 1px solid #ADC3E8;
    }
}
.img{
    position: absolute;
    bottom: 0;
    right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/backstageManagement/guide/SideNav.vue